import { line } from "d3-shape";
import { scaleSequential, scaleLinear } from "d3-scale";
import { interpolateSinebow, interpolateSpectral } from "d3-scale-chromatic";
import { range } from "d3-array";
import { easeCubic } from "d3-ease";
import { timer } from "d3-timer";
import { create, select, selectAll, event } from "d3-selection";
import { drag } from "d3-drag";
import { zoom, zoomIdentity } from "d3-zoom";
import { curveLinear, curveCatmullRom } from "d3-shape";
import { geoMercator, geoDistance, geoInterpolate, geoGraticule, geoPath, geoCentroid} from "d3-geo";
import { color } from "d3-color";

// Voronoi:
import {Delaunay} from "d3-delaunay";
import {contours} from "d3-contour";

const EARTH_RADIUS = 6371000;
const geoDistanceMeters = (EN1, EN2) => geoDistance(EN1, EN2) * EARTH_RADIUS;

const d3 = {
    // d3-shape
    line,
    // d3-scale
    scaleSequential, scaleLinear,
    // d3-scale-chromatic
    interpolateSinebow, interpolateSpectral,
    // d3-array
    range,
    // d3-ease
    easeCubic,
    // d3-timer
    timer,
    // d3-selection
    create, select, selectAll,
    // d3-drag
    drag,
    // d3-zoom
    zoom, zoomIdentity,
    // d3-shape
    curveLinear, curveCatmullRom,
    // d3-geo
    geoMercator, geoDistance, geoDistanceMeters, geoInterpolate, geoGraticule, geoPath, geoCentroid,
    // d3-delaunay
    Delaunay,
    // d3-countour
    contours,
    // d3-color
    color
};

Object.defineProperty(d3, "event", {
    set: () => {},
    get: () => event
});

export {d3};
